import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15,
  _t16;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.includes.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import translations from './translations';
import * as dayjs from 'dayjs';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import css from './style.pcss';
import TraficIconAccident from "./images/icon-trafic/accident.png";
import TraficIconAttention from "./images/icon-trafic/attention.png";
import TraficIconGreendot from "./images/icon-trafic/greendot.png";
import TraficIconPolice from "./images/icon-trafic/police.png";
import TraficIconRoadworks from "./images/icon-trafic/roadworks.png";
import TraficIconTrafic from "./images/icon-trafic/trafic.png";
import TraficBackground from "./images/trafic_bg.jpg";
import LogoAcl from "./images/logo_acl.svg";
import LogoITLF from "./images/logo-itlf.svg";
import MobiliteitImage from "./images/mobiliteit.png";
import IcFullscreen from "./images/ic_fullscreen.svg";
import IcFullscreenExit from "./images/ic_fullscreen_exit.svg";
var TraficIcons = {
  accident: TraficIconAccident,
  attention: TraficIconAttention,
  greendot: TraficIconGreendot,
  police: TraficIconPolice,
  roadworks: TraficIconRoadworks,
  trafic: TraficIconTrafic
};
var RTLTrafic = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLTrafic, _LitElement);
  function RTLTrafic() {
    var _this;
    _classCallCheck(this, RTLTrafic);
    _this = _callSuper(this, RTLTrafic);
    _this.allowedTypes = ['acl', 'vv', 'tmc', 'cfl', 'map'];
    _this.language = 'lu';
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
    }
    _this._apiUrl = "https://api-gate.rtl.lu/traffic";
    _this.showMoreMobile = false;
    return _this;
  }
  _createClass(RTLTrafic, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLTrafic.prototype), "connectedCallback", this).call(this);
      if (this.type != 'map') this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function () {
      var _fetchData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var type, tmc, infos, acl, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              type = this.type;
              _context.t0 = this.language;
              _context.next = _context.t0 === "fr" ? 4 : _context.t0 === "en" ? 6 : 8;
              break;
            case 4:
              type = "5minutes";
              return _context.abrupt("break", 8);
            case 6:
              type = "today";
              return _context.abrupt("break", 8);
            case 8:
              _context.next = 10;
              return fetch(this._apiUrl + "/events?language=" + (this.language === "lu" ? "lb" : this.language)).then(function (resp) {
                return resp.json();
              });
            case 10:
              tmc = _context.sent;
              _context.next = 13;
              return fetch(`${this._apiUrl}/infos?providers=${type}&language=${this.language}`).then(function (resp) {
                return resp.json();
              });
            case 13:
              infos = _context.sent;
              acl = infos.map(function (info) {
                return {
                  txt: info.txt,
                  //nl2br
                  updated: info.updated //fix date
                };
              });
              data = {
                acl: acl,
                tmc: tmc_resolve_data(tmc)
              };
              this.data = data;
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _fetchData() {
        return _fetchData2.apply(this, arguments);
      }
      return _fetchData;
    }()
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_doFullscreen",
    value: function _doFullscreen(e) {
      var btLabel = this.shadowRoot.querySelector('.button__label');
      var map = this.shadowRoot.querySelector('.rtl-trafic-map');
      var bt = e.target;
      bt.classList.toggle('rtl-trafic-map__fullscreen--open');
      map.classList.toggle('rtl-trafic-map--fullscreen');
      if (map.classList.contains('rtl-trafic-map--fullscreen')) btLabel.innerHTML = "Exit full screen";else btLabel.innerHTML = "Full screen";
    }
  }, {
    key: "_renderByType",
    value: function _renderByType(type) {
      if (!this.allowedTypes.includes(type)) return 'TYPE must be one of the following: acl, cfl, vv, tmc';
      var data;
      var output = '';
      if (type != 'map') data = this.data[type];
      switch (type) {
        case 'tmc':
          output = this._renderTMC(data);
          break;
        case 'map':
          output = this._renderMap();
          break;
        case 'acl':
          output = this._renderACL(data);
          break;
        case 'vv':
          output = this._renderVV(data);
          break;
      }
      return output;
    }
  }, {
    key: "_renderAll",
    value: function _renderAll() {
      var output = html(_t || (_t = _`
            ${0}
            ${0}
            ${0}
            ${0}
        `), this._renderByType('map'), this._renderByType('acl'), this._renderByType('vv'), this._renderByType('tmc'));
      return output;
    }
  }, {
    key: "_setTMCTab",
    value: function _setTMCTab(e, tab) {
      this.shadowRoot.querySelector('.rtl-trafic-tmc__title--active').classList.remove('rtl-trafic-tmc__title--active');
      e.target.classList.add('rtl-trafic-tmc__title--active');
      if (tab == 'info') {
        this.shadowRoot.querySelector('.rtl-trafic-tmc__info-container').classList.remove('is-hidden');
        this.shadowRoot.querySelector('.rtl-trafic-tmc__chantier-container').classList.add('is-hidden');
      }
      if (tab == 'roadworks') {
        this.shadowRoot.querySelector('.rtl-trafic-tmc__info-container').classList.add('is-hidden');
        this.shadowRoot.querySelector('.rtl-trafic-tmc__chantier-container').classList.remove('is-hidden');
      }
    }
  }, {
    key: "_renderTMC",
    value: function _renderTMC(data) {
      var _this2 = this;
      if (!data) return;
      var output = '';
      var class2add = ` flavor-${this.language}`;
      var showMoreButton = html(_t2 || (_t2 = _`<div class="button-container"><div class="button-default-co" @click=${0}>${0}</div></div>`), function () {
        return _this2.showMoreMobile = true;
      }, this._getTranslation('show-more-mobile'));
      if (this.showMoreMobile) {
        showMoreButton = html(_t3 || (_t3 = _`<div class="button-container-co"><div class="button-default-co" @click=${0}>${0}</div></div>`), function () {
          return _this2.showMoreMobile = false;
        }, this._getTranslation('show-less-mobile'));
      }
      if (data.info.length > 0) {
        output = html(_t4 || (_t4 = _`
                <div class="rtl-trafic-tmc${0}">

                    <div class="rtl-trafic-tmc__button-container">
                        <h2 class="rtl-trafic-tmc__title rtl-trafic-tmc__title--active rtl-trafic-tmc__info-title" @click=${0}>${0} (${0})</h2>
                        <h2 class="rtl-trafic-tmc__title" @click=${0}>${0} (${0})</h2>
                    </div>

                    <div class="rtl-trafic-tmc__info-container bloc-width">
                        <div class="rtl-trafic-tmc__style rtl-trafic-tmc__info-wrapper">
                            ${0}
                            ${0}
                        </div>
                    </div>

                    <div class="rtl-trafic-tmc__chantier-container is-hidden bloc-width">
                        <div class="rtl-trafic-tmc__style rtl-trafic-tmc__chantier-wrapper">
                            ${0}
                            ${0}
                        </div>
                    </div>
                </div>
            `), class2add, function (e) {
          return _this2._setTMCTab(e, 'info');
        }, this._getTranslation('tmc-info'), data.info.length, function (e) {
          return _this2._setTMCTab(e, 'roadworks');
        }, this._getTranslation('tmc-chantiers'), data.chantiers.length, data.info.map(function (item, count) {
          var hideMobileClass = "";
          if (count >= 3 && !_this2.showMoreMobile) {
            hideMobileClass = "hide-on-mobile";
          }
          return html(_t5 || (_t5 = _`
                                    <div class=${0}>
                                        <div class="rtl-trafic-tmc__info-img-container"><img class="rtl-trafic-tmc__img rtl-trafic-tmc__info-img" src="/assets/images/trafic/icon-trafic/${0}"/></div>
                                        <div class="rtl-trafic-tmc__info-list"><b class="rtl-trafic-tmc__info-list--bold">${0} - ${0} ${0}</b><br><i>${0}</i></div>
                                    </div>
                                `), "rtl-trafic-tmc__info bloc-position " + hideMobileClass, item.icon, dayjs(item.timestamp).format('DD.MM.YYYY / HH:mm'), item.roadtext, item.segmenttext, item.eventtext);
        }), showMoreButton, data.chantiers.map(function (item, count) {
          var hideMobileClass = "";
          if (count >= 3 && !_this2.showMoreMobile) {
            hideMobileClass = "hide-on-mobile";
          }
          return html(_t6 || (_t6 = _`
                                    <div class=${0}>
                                        <div class="rtl-trafic-tmc__info-img-container"><img class="rtl-trafic-tmc__img rtl-trafic-tmc__info-img" src="/assets/images/trafic/icon-trafic/${0}"/></div>
                                        <div class="rtl-trafic-tmc__info-list"><b class="rtl-trafic-tmc__info-list--bold">${0} - ${0} ${0}</b><br><i>${0}</i></div>
                                    </div>
                                `), "rtl-trafic-tmc__info bloc-position " + hideMobileClass, item.icon, dayjs(item.timestamp).format('DD.MM.YYYY / HH:mm'), item.roadtext, item.segmenttext, item.eventtext);
        }), showMoreButton);
      }
      return output;
    }
  }, {
    key: "_renderACL",
    value: function _renderACL(data) {
      if (!data) return;
      var output = '';
      if (data.length == 0) {
        if (this.verbose) {
          output = html(_t7 || (_t7 = _`
                    <div class="rtl-trafic-${0}">
                        <h2>${0}</h2>
                        <b>${0}</b>
                    </div>
                `), type, this._getTranslation(type), this._getTranslation('nodata'));
        }
        return output;
      }
      var class2addLU = '';
      if (this.showall) class2addLU = ' rtl-trafic-acl--showall';
      var class2addFR = '';
      if (this.showall) class2addFR = ' rtl-trafic-acl-itlf--showall';
      if (this.language == 'fr') {
        output = html(_t8 || (_t8 = _`
                <div class="rtl-trafic-acl${0}">
                    <div class="rtl-trafic-acl__title-container">
                        <a href="/mobiliteit/trafic" class="rtl-trafic-acl__title"><span class="rtl-trafic-acl__count">${0}</span> Info Trafic</a>
                        <div class="rtl-trafic-acl__img-container">
                            <img class="rtl-trafic-itlf__img" src="${0}" alt="ITLF"/>
                            <a href="https://www.acl.lu" target="_blank"><img class="rtl-trafic-acl__img" src="${0}" alt="ACL"/></a>
                        </div>
                    </div>
                    <div class="rtl-trafic-acl__info-container">
                        <ul class="rtl-trafic-acl__info">
                        ${0}
                        </ul>
                    </div>
                    <a href="/mobiliteit/trafic" class="rtl-trafic-acl__more">
                        ${0} →
                    </a>
                    <a href="/mobilite" class="rtl-trafic-acl__blocklink">${0}</a>
                </div>
            `), class2addLU, data.length, LogoITLF, LogoAcl, data.map(function (item) {
          return html(_t9 || (_t9 = _`
                            <li class="rtl-trafic-acl__info-list"><b class="rtl-trafic-acl__hours">${0}</b> <div>${0}</div></li>
                        `), dayjs(item.updated).format('DD.MM | HH:mm'), unsafeHTML(item.txt));
        }), this._getTranslation('more'), this._getTranslation('more'));
      } else {
        output = html(_t10 || (_t10 = _`
                <div class="rtl-trafic-acl${0}">
                    <div class="rtl-trafic-acl__title-container">
                        <a href="/mobiliteit/trafic" class="rtl-trafic-acl__title"><span class="rtl-trafic-acl__count">${0}</span> Live aus dem Trafic-Studio</a>
                        <div class="rtl-trafic-acl__img-container">
                            <a href="https://www.acl.lu" target="_blank"><img class="rtl-trafic-acl__img" src="${0}" alt="ACL"/></a>
                        </div>
                    </div>
                    <div class="rtl-trafic-acl__info-container">
                        <ul class="rtl-trafic-acl__info">
                        ${0}
                        </ul>
                    </div>
                    <a href="/mobiliteit/trafic" class="rtl-trafic-acl__more">
                        ${0} →
                    </a>
                    <a href="/mobiliteit/trafic" class="rtl-trafic-acl__blocklink">${0}</a>
                </div>
            `), class2addLU, data.length, LogoAcl, data.map(function (item) {
          return html(_t11 || (_t11 = _`
                            <li class="rtl-trafic-acl__info-list"><b class="rtl-trafic-acl__hours">${0}</b>
                            <div>${0}</div></li>
                        `), dayjs(item.updated).format('DD.MM | HH:mm'), unsafeHTML(item.txt));
        }), this._getTranslation('more'), this._getTranslation('more'));
      }
      return output;
    }
  }, {
    key: "_renderVV",
    value: function _renderVV(data) {
      if (!data) return;
      var output = '';
      if (data.length == 0) {
        if (this.verbose) {
          output = html(_t12 || (_t12 = _`
                    <div class="rtl-trafic-${0}">
                        <h2>${0}</h2>
                        <b>${0}</b>
                    </div>
                `), this.type, this._getTranslation(type), this._getTranslation('nodata'));
        }
        return output;
      }
      var class2add = '';
      if (this.showall) class2add = ' rtl-trafic-vv--showall';
      output = html(_t13 || (_t13 = _`
                <div class="rtl-trafic-${0}${0}">
                    <div class="rtl-trafic-vv__container">
                        <img class="rtl-trafic-vv__img" src="${0}" alt="Mobiliteit"/>
                    </div>
                    <div class="rtl-trafic-vv__info-container">
                        <h1 class="rtl-trafic-vv__title">Verkéiersverbond</h1>
                        <div class="rtl-trafic-vv__info-wrapper">
                            <ul class="rtl-trafic-vv__info">
                            ${0}
                            </ul>
                        </div>
                    </div>
                </div>
            `), this.type, class2add, MobiliteitImage, data.map(function (item) {
        return html(_t14 || (_t14 = _`
                            <li class="rtl-trafic-vv__info-list"><b class="rtl-trafic-vv__hours">${0}</b> <div class="rtl-trafic-vv__info-text">${0}</div></li>
                            `), dayjs(item.updated).format('DD.MM | HH:mm'), unsafeHTML(item.txt));
      }));
      return output;
    }
  }, {
    key: "_renderMap",
    value: function _renderMap() {
      var _this3 = this;
      var output = '';
      var lang = 'fr_lu'; // Default de_LU soubaal alles iwersaat ass

      if (this.language == 'fr') {
        lang = 'fr_lu';
      }
      if (this.language == 'en') {
        lang = 'en_US';
      }
      output = html(_t15 || (_t15 = _`
            <div class="rtl-trafic-map">
                <iframe scrolling="no" src="https://atlas.be-mobile.biz/?config=5daf7e436cedf9159ed8492c&language.language=${0}" width="100%" class="rtl-trafic-map__iframe"></iframe>
                <div class="rtl-trafic-map__fullscreen button-default-co" @click=${0}>
                    <span class="button__label">Full screen</span>
                    <span class="rtl-trafic-map-fullscreen__open button__icon">
                        <img src="${0}" alt="Fullscreen" class="is-hidden" /></span><span class="rtl-trafic-map-fullscreen__exit button__icon">
                        <img src="${0}" alt="Exit fullscreen" /></span>
                    </div>
            </div>`), lang, function (e) {
        return _this3._doFullscreen(e);
      }, IcFullscreen, IcFullscreenExit);
      return output;
    }
  }, {
    key: "render",
    value: function render() {
      if (this.data == undefined && this.type != 'map') return;
      return html(_t16 || (_t16 = _`
            <style>${0}</style>

            ${0}
        `), css, this.type ? this._renderByType(this.type) : this._renderAll());
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        type: {
          type: String
        },
        verbose: {
          type: Boolean
        },
        language: {
          type: String
        },
        showall: {
          type: Boolean
        },
        showMoreMobile: {
          type: Boolean
        }
      };
    }
  }]);
  return RTLTrafic;
}(LitElement);
export { RTLTrafic as default };
var tmc_resolve_data = function tmc_resolve_data(data) {
  var events = [];
  var roadworks = [];
  var _iterator = _createForOfIteratorHelper(data),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var event = _step.value;
      if (event.type === 'roadworks') {
        roadworks.push(event);
      } else {
        events.push(event);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return {
    info: tmc_format_infos(events),
    chantiers: tmc_format_infos(roadworks)
  };
};
var tmc_format_infos = function tmc_format_infos(data) {
  return data.map(function (item) {
    return {
      icon: tmc_resolve_icon(item.type),
      roadtext: item.road_text,
      directiontext: item.direction_text,
      eventtext: item.event_text,
      segmenttext: item.segment_text,
      timestamp: fix_date(item.last_modified)
    };
  });
};
var tmc_resolve_icon = function tmc_resolve_icon(type) {
  switch (type) {
    case 'traffic':
      return 'trafic.png';
    case 'accident':
      return 'accident.png';
    case 'roadworks':
      return 'roadworks.png';
    case 'police':
      return 'police.png';
    default:
      return 'attention.png';
  }
};
var fix_date = function fix_date(date) {
  return new Date(date).toISOString();
};
window.customElements.define('rtl-trafic', RTLTrafic);